import {DetailsList, Icon, IconButton, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddChecklistItem from "../Panel/Checklist/AddChecklistItem";
import EditChecklistItem from "../Panel/Checklist/EditChecklistItem";
import {useOutletContext} from "react-router-dom";

function ChecklistItem(props) {
    const [user] = useContext(AuthContext);
    const [checklistItems, setChecklistItems] = useState([]);
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/checklist", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setChecklistItems(data)
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [editChecklistItem, setEditChecklistItem] = useState(false);
    const [addChecklistItem, setAddChecklistItem] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addChecklistItem',
                text: 'Dodaj Punkt Kontrolny',
                iconProps: {iconName: 'Add'},
                onClick: () => setAddChecklistItem(true)
            }
        ]);
        return actions;
    }, []);

    const columns = [
        {
            key: 'item',
            name: 'Nazwa',
            ariaLabel: 'Nazwa Punktu Kontrolnego',
            fieldName: 'item',
            minWidth: 210,
            isRowHeader: true,
            isResizable: true,
        },
        {
            key: 'default',
            name: 'Domyślny',
            ariaLabel: 'Domyślny',
            fieldName: 'default',
            minWidth: 70,
            maxWidth: 70,
            onRender: (item) => ( item.default ? <Icon iconName={'CheckMark'} title='Tak'/> : '')
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 90,
            maxWidth: 90,
            onRender: (item) => (<span>
                <IconButton iconProps={{iconName: 'edit'}} title='Edytuj' onClick={() => setEditChecklistItem(item)}/>
                <IconButton iconProps={{iconName: 'delete'}} title='Usuń' onClick={() => _deleteChecklistItem(item)}/>
            </span>)
        }
    ];
    const _deleteChecklistItem = (item) => {
        fetch(`/api/checklist/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                setRefresh(refresh + 1)
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <AppContent title={'Punkty Kontrolne'}>
            <DetailsList items={checklistItems} columns={columns} selectionMode={SelectionMode.none}/>
            <AddChecklistItem add={addChecklistItem} onSuccess={() => setRefresh(refresh + 1)}
                              dismissPanel={() => setAddChecklistItem(false)}/>
            <EditChecklistItem edit={editChecklistItem} onSuccess={() => setRefresh(refresh + 1)}
                               dismissPanel={() => setEditChecklistItem(false)}/>
        </AppContent>
    );
}

export default ChecklistItem;